import axios, { AxiosError, AxiosInstance } from 'axios';
import { getAccessToken } from '../lib/getAccessToken';

// Notify Application Insights of the error, and re-reject the error so
// error handling elsewhere can be performed as usual.
const trackAxiosError = (error: AxiosError) => {
  window.$nuxt.$appInsights.trackException({
    exception: error,
    // Provide data that will help during debugging.
    properties: {
      request: error.request,
      response: error.response
    }
  });
  return Promise.reject(error);
};

export function createAxios(baseURL: string = null): AxiosInstance {
  const axiosInstance = axios.create({
    // To use runtimeConfig, implement this similar to one of:
    //   https://nuxtjs.org/guide/plugins/#inject-into-context
    // eslint-disable-next-line no-undef
    baseURL: baseURL ?? process.env.ApiBaseUrl,
    headers: { Authorization: 'Bearer ' + getAccessToken() }
  });

  axiosInstance.interceptors.request.use(null, trackAxiosError);
  // Any status codes that fall outside the range of 2xx trigger the
  // tracking function.
  axiosInstance.interceptors.response.use(null, trackAxiosError);

  return axiosInstance;
}
